import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ErrorResource {
  static NOT_CONNECTION = 'Revise su conexión a internet';
  static SERVER_ERROR = 'Error de servidor';
  static NOT_FOUND = 'El servidor no puede resolver esta petición';

  constructor() {}

  public static getError(code, message = '', error = null) {
    let msg = '';
    switch (code) {
      case 0:
        msg = ErrorResource.NOT_CONNECTION;
        break;
      case 500:
        msg = ErrorResource.SERVER_ERROR;
        break;
      case 400:
        msg = ErrorResource.NOT_FOUND;
        break;
      case 404:
        msg = ErrorResource.NOT_FOUND;
        break;
      default:
        msg = message;
    }
    if (error) {
      if (error.error) {
        msg = error.error.data
          ? this.getErrorDataMessage(error.error.data)
          : error.error.message
            ? error.error.message
            : msg;
      }
    }
    return msg;
  }

  public static getErrorDataMessage(data) {
    let msg = '';
    for (const key in data) {
      msg += data[key][0];
    }
    return msg;
  }
}
